import styled, { css } from 'styled-components';

import Image from 'next/image';
import useDevice from '@hooks/useDevice';
import { device } from '@styles/mediaQuery';
import { WhyWeService } from '@shared/constants/whyWe';

function Service({ iconSrc, title, description, target }: WhyWeService) {
  const { isMobile, isTablet } = useDevice();

  const splitText = description.split(target);

  return (
    <Wrapper>
      <ImageWrapper>
        <Image width={72} height={72} alt={iconSrc} src={iconSrc} loading="lazy" />
      </ImageWrapper>

      {(isMobile || isTablet) && <StyledTitle>{title}</StyledTitle>}

      {!(isMobile || isTablet) && (
        <CardWrapper>
          <StyledTitle>{title}</StyledTitle>
          <StyledDescription>
            {splitText[0]}
            <StyledBoldDescription>{target}</StyledBoldDescription>
            {splitText[1]}
          </StyledDescription>
        </CardWrapper>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 48%;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  height: 130px;
  max-width: 330px;
  margin-bottom: 20px;

  ${device.tablet(css`
    width: 33%;
  `)}

  ${device.laptopS(css`
    margin-bottom: 0;
    height: auto;
  `)}
`;

const ImageWrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1;
`;

const CardWrapper = styled.div`
  position: relative;
  top: -22px;

  width: 90%;
  max-width: 330px;
  height: 175px;
  padding: 30px 20px 0;

  display: flex;
  align-items: center;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.cardBackground};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  border-radius: 16px;

  line-height: 22px;
`;

const StyledTitle = styled.div`
  font-weight: 600;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const StyledDescription = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const StyledBoldDescription = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export default Service;
